import { Component, OnInit } from '@angular/core';
import {CustomDisabledDirective} from '../../shared/directives/custom-disabled.directive'
@Component({
    moduleId: module.id,
    selector: 'app-root',
    templateUrl: './home.component.html'
    
    
})
export class HomeComponent{}
